import { StyleProp, TextStyle } from "react-native";
import { Text, useTheme } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

type Props = {
  text: string;
  style?: StyleProp<TextStyle>;
};

function Title({ text, style }: Props) {
  const tailwind = useTailwind();
  return (
    <Text variant="bodyLarge" style={[tailwind("font-medium"), style]}>
      {text}
    </Text>
  );
}

function Subtitle({ text, style }: Props) {
  const { colors } = useTheme();
  const tailwind = useTailwind();

  const color = colors.onSurfaceVariant;

  return (
    <Text
      variant="bodyMedium"
      style={[tailwind("font-bold"), { color }, style]}
    >
      {text}
    </Text>
  );
}

function Body({ text, error, style }: Props & { error?: boolean }) {
  const { colors } = useTheme();

  const color = error ? colors.error : colors.onSurfaceVariant;

  return (
    <Text variant="bodyMedium" style={[{ color }, style]}>
      {text}
    </Text>
  );
}

function Label({ text, style }: Props) {
  const { colors } = useTheme();
  const color = colors.onSurfaceVariant;

  return (
    <Text variant="labelMedium" style={[{ color }, style]}>
      {text}
    </Text>
  );
}

export default { Title, Subtitle, Body, Label };
